import React from 'react';

export function WareHouseDraw() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="515"
      height="231"
      fill="none"
      viewBox="0 0 515 231"
    >
      <path
        stroke="#000"
        d="M5.5 228V48.5m14-22h-14v10m14-10l50-5.063 41.5-4.203M19.5 26.5v10m475-10h14v10m-14-10v10m0-10L444 21.408l-41-4.135M508.5 228.5h5c.167.667.4 2 0 2h-24v-2h5m14 0v-180m0 180h-14m0 0v-180m0-12h14m-14 0v12m0-12L403 27.273M508.5 36.5v12m0 0h-14m0 0L444 31.408M19.5 36.5v12m0-12h-14m14 0l91.5-9.266M19.5 228.5h5v2H.5v-2h19zm0 0v-180m-14 0h14m-14 0v-12m14 12l50-17.063M111 17.234L256.5 2.5 403 17.273m-292-.039v10m0 0L256.5 12.5 403 27.273M256.5 1v13m0-13l2.281 1.73M256.5 1l-2.271 1.73M256.5 14l2.281-1.27M256.5 14l-2.271-1.27M403 17.273v10"
      />
    </svg>
  );
}
